document.addEventListener("DOMContentLoaded", function () {
  // check if footer is in viewport

  const footer = document.querySelector(".section-footer__row-container--with-localization");
  const footerHeight = footer.offsetHeight;

  const footerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("footer-in-viewport");
        } else {
          document.body.classList.remove("footer-in-viewport");
        }
      });
    },

    {
      root: null,
      rootMargin: `-${footerHeight}px 0px 0px 0px`,
      threshold: 0,
    }
  );

  footerObserver.observe(footer);
});
